import t from "../../Actions/LotSmartActions/types";

const initialState = {
  merchants: [],
  rates: [],
  specialRates: [],
  auditLogs: [],
  auditCount: 0,
  gateResult: null,
  loader: false,
};

const LotSmartReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.FETCH_LOTSMART_MERCHANTS:
      return { ...state, merchants: action.payload };
    case t.FETCH_LOTSMART_RATES:
      return { ...state, rates: action.payload };
    case t.FETCH_LOTSMART_SPECIAL_RATES:
      return { ...state, specialRates: action.payload };
    case t.FETCH_LOTSMART_AUDIT_LOGS:
      return { ...state, auditLogs: action.payload?.data || [], auditCount: action.payload?.count || 0 };
    case t.LOTSMART_GATE_RESULT:
      return { ...state, gateResult: action.payload };
    case t.LOTSMART_LOADER:
      return { ...state, loader: action.payload };
    default:
      return state;
  }
};

export default LotSmartReducer;
